import type { ChecklistItem as BoardChecklistItem } from '../../types/schema'
import { isGateConnected } from './wireGeometry'

export const executeDeleteGate = ({
  node,
  displayNodes,
  boardDocumentIds = new Set<string>(),
  canDeleteChecklist = true,
  flashLocal,
  showFlash,
  pendingDeletions,
  commitLocalNodes,
}: {
  node: BoardChecklistItem
  displayNodes: BoardChecklistItem[]
  boardDocumentIds?: Set<string>
  canDeleteChecklist?: boolean
  flashLocal: (message: string) => void
  showFlash?: (message: string) => void
  pendingDeletions?: Set<string>
  commitLocalNodes: (updater: (current: BoardChecklistItem[]) => BoardChecklistItem[]) => void
}): boolean => {
  if (isGateConnected(node, displayNodes)) {
    flashLocal('Cannot delete a connected Gate.')
    return false
  }
  if (boardDocumentIds.has(node.id)) {
    if (!canDeleteChecklist) {
      ;(showFlash ?? flashLocal)('You do not have permission to delete checklist items.')
      return false
    }
    pendingDeletions?.add(node.id)
  }
  commitLocalNodes((current) =>
    current
      .filter((candidate) => candidate.id !== node.id)
      .map((candidate) => ({
        ...candidate,
        prerequisites: candidate.prerequisites.filter((id) => id !== node.id),
        gateInputIds: (candidate.gateInputIds ?? []).filter((id) => id !== node.id),
      })),
  )
  return true
}
